const Experience = () => {
  const experiences = [
    {
      title: "Web Developer",
      company: "iOptime",
      location: "Islamabad",
      duration: "Nov 2024 - Jan 2025",
      description: [
        "Developed and maintained responsive web applications",
        "Collaborated with cross-functional teams to deliver high-quality solutions",
        "Implemented modern web technologies and best practices",
        "Participated in code reviews and technical discussions"
      ]
    }
  ];

  return (
    <section id="experience" className="py-20 bg-black">
      <div className="container mx-auto px-4 mt-14">
        <h2 className="text-4xl font-bold text-center mb-10 text-purple-800">Professional Experience</h2>
        <div className="max-w-4xl mx-auto ">
          {experiences.map((exp, index) => (
            <div key={index} className="mb-8 bg-gray-800 rounded-lg border-2 border-purple-800 p-6">
              <h3 className="text-2xl font-semibold text-white">{exp.title}</h3>
              <div className="text-gray-100 mt-2">
                <p className="font-medium text-gray-100">{exp.company} - {exp.location}</p>
                <p className="text-sm text-gray-100">{exp.duration}</p>
              </div>
              <ul className="mt-4 text-gray-100 list-disc list-inside text-gray-700">
                {exp.description.map((item, idx) => (
                  <li key={idx} className="mb-2 text-gray-100">{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
